(function () {
  if (!window.HbElements) return;

  const HIDDEN_CLASS = 'hb-event-hidden';

  class HbVisibility extends HbElements.Component {
    onConnect() {
      this.eventName = (this.dataset.event || '').trim();
      this.initial = this.dataset.initial === 'hidden' ? 'hidden' : 'visible';
      this.onMatch = this.dataset.onMatch === 'visible' ? 'visible' : 'hidden';
      this.matchOn = this.dataset.match || 'none';
      this.matchPurchase = this.dataset.matchPurchase || 'subscribe';
      this.matchKey = this.dataset.matchKey || 'value';
      this.matchValue = this.dataset.matchValue || '';
      this.productId = this.dataset.productId || '';
      this.designMode = Boolean(window.Shopify && Shopify.designMode);

      this.onEvent = this.onEvent.bind(this);

      if (!this.eventName) return;

      this.applyState(this.initial);
      document.addEventListener(this.eventName, this.onEvent);
      this.syncFromPage();
    }

    onDisconnect() {
      if (!this.eventName) return;
      document.removeEventListener(this.eventName, this.onEvent);
    }

    onEvent(event) {
      const detail = (event && event.detail) || {};
      if (!this.matchesProductScope(detail)) return;
      if (this.matchesValue(detail)) {
        this.applyState(this.onMatch);
        return;
      }
      this.applyState(this.initial);
    }

    matchesProductScope(detail) {
      const eventProductId = detail.productId != null ? String(detail.productId) : '';
      if (!this.productId || !eventProductId) return true;
      return eventProductId === String(this.productId);
    }

    matchesValue(detail) {
      if (this.matchOn === 'none') return true;
      if (this.matchOn === 'product_id') {
        return String(detail.productId != null ? detail.productId : '') === this.matchValue;
      }
      if (this.matchOn === 'variant_id') {
        return String(detail.variantId != null ? detail.variantId : '') === this.matchValue;
      }
      if (this.matchOn === 'purchase_option') {
        const purchase = detail.sellingPlanId ? 'subscribe' : 'one_time';
        return purchase === this.matchPurchase;
      }
      if (this.matchOn === 'custom') {
        const key = this.matchKey || 'value';
        const raw = detail[key];
        return String(raw != null ? raw : '') === this.matchValue;
      }
      return true;
    }

    applyState(state) {
      if (this.designMode) {
        this.classList.remove(HIDDEN_CLASS);
        this.removeAttribute('aria-hidden');
        this.removeAttribute('inert');
        return;
      }

      const hide = state === 'hidden';
      this.classList.toggle(HIDDEN_CLASS, hide);
      if (hide) {
        this.setAttribute('aria-hidden', 'true');
        this.setAttribute('inert', '');
        return;
      }
      this.removeAttribute('aria-hidden');
      this.removeAttribute('inert');
    }

    syncFromPage() {
      if (this.eventName === 'hb:selling-plan-change') {
        this.syncSellingPlan();
        return;
      }
      if (this.eventName === 'hb:variant-change') {
        this.syncVariant();
      }
    }

    findHost(selector) {
      const hosts = Array.from(document.querySelectorAll(selector));
      if (!this.productId) return hosts[0] || null;
      return (
        hosts.find((el) => {
          const id = el.dataset.productId || '';
          return !id || id === String(this.productId);
        }) || null
      );
    }

    syncSellingPlan() {
      const host = this.findHost('hb-selling-plans');
      if (!host) return;
      const selected = host.querySelector('[data-purchase].is-selected');
      const subscribe = selected ? selected.dataset.purchase === 'subscribe' : false;
      let sellingPlanId = '';
      if (subscribe) {
        const select = host.querySelector('[data-selling-plan-select]');
        sellingPlanId = select && select.value ? select.value : 'subscribe';
      }
      this.onEvent({
        detail: {
          productId: host.dataset.productId || this.productId,
          variantId: host.dataset.initialVariantId || '',
          sellingPlanId,
        },
      });
    }

    syncVariant() {
      const formHost = this.findHost('hb-product-form');
      const form =
        (formHost && (formHost.querySelector('form[data-type="add-to-cart-form"]') || formHost.querySelector('form'))) ||
        null;
      const idInput = form ? form.querySelector('[name="id"]') : null;
      this.onEvent({
        detail: {
          productId: (formHost && formHost.dataset.productId) || this.productId,
          variantId: idInput ? idInput.value : '',
        },
      });
    }
  }

  HbElements.define('hb-visibility', HbVisibility);
})();
